// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3zbIV","amount":"Amount_amount__2AGun","tip":"Amount_tip__1Gqh4","tipHeader":"Amount_tipHeader__2BHqD","tipsWrap":"Amount_tipsWrap__2nlpO"};